import axios from 'axios';

const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/sousfamille`; // Adjust this as necessary

// ... other CRUD functions

export const bulkUploadSousFamilles = (formData) => axios.post(`${API_BASE_URL}/bulk-upload`, formData, {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
});